'use client'

import Link from 'next/link'
import { PawIcon, CatIcon, DogIcon, HamsterIcon, ArrowRightIcon } from './icons'

const CATEGORIES = [
  { icon: CatIcon, label: 'Cat', handle: 'cat' },
  { icon: DogIcon, label: 'Dog', handle: 'dog' },
  { icon: HamsterIcon, label: 'Small Animals', handle: 'small-animals' },
]

export function PetSelectHero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#0B7A75] via-[#0D8F89] to-[#065A55] max-h-[40vh] min-h-[320px]">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 flex flex-col justify-center h-full">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Left: Text content */}
          <div className="lg:max-w-xl">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1.5 mb-4">
              <PawIcon className="w-3.5 h-3.5 text-white/80" />
              <span className="text-white/90 text-[11px] font-medium tracking-wider uppercase">Australia&apos;s Pet Store</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 tracking-tight leading-tight">
              Everything Your Pet
              <span className="text-[#FF6B35]"> Needs & Loves</span>
            </h1>

            <p className="text-sm md:text-base text-white/75 max-w-lg mb-5 font-light leading-relaxed">
              Premium food, toys, and accessories. Trusted brands, fast shipping across Australia.
            </p>

            <div className="flex flex-wrap items-center gap-3">
              <Link
                href="/store"
                className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E55A2B] text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#FF6B35]/25 text-xs tracking-wide"
              >
                Shop All Products
                <ArrowRightIcon className="w-3.5 h-3.5" />
              </Link>
              <Link
                href="/categories/cat"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium px-6 py-2.5 rounded-full transition-all duration-300 border border-white/20 text-xs tracking-wide"
              >
                Browse Categories
              </Link>
            </div>
          </div>

          {/* Right: Category quick-links */}
          <div className="flex lg:flex-col gap-3">
            {CATEGORIES.map((cat) => {
              const Icon = cat.icon
              return (
                <Link
                  key={cat.handle}
                  href={`/categories/${cat.handle}`}
                  className="group flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-xl px-4 py-3 transition-all duration-300 border border-white/10 hover:border-white/30"
                >
                  <Icon className="w-6 h-6 text-white/90 group-hover:scale-110 transition-transform duration-300" />
                  <div className="text-left">
                    <span className="block text-white font-semibold text-xs">{cat.label}</span>
                    <span className="block text-white/50 text-[10px]">Shop now</span>
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
